import React from 'react'

import {SettingsSection, SettingsSectionTitleDict} from "../../../../../app/settings/@const"
import NavigationMenuSection from "../../../menu-items/section/section"
import NavigationSection from "../../../../../core/model2/navigation/navigation-section"
import {SettingsItemType} from "../@type"
import MenuSettings_Items from "../settings-menu-items"

type Props = {
    collapseState       : any,
    navigationSection   : NavigationSection

    onToggle            : (a: string, b: boolean)=>void
}

export default function OrganizationSettings(props: Props) {

    const onToggle = (isOpen: boolean) => {
        props.onToggle('organization-settings', isOpen)
    }

    // Company Users -> HR ?

    const items: SettingsItemType[] = [
        {
            name    : "All settings",
            icon    : "i5-nav-settings",
            url     : `settings/${SettingsSection.COMPANY_ALL}`,
        },
        {
            name    : "Tasks & Projects",
            icon    : "i5-nav-projects",
            url     : `settings/${SettingsSection.TASKS_PROJECTS}`,
        },
        {
            name    : "Productivity & Collaboration",
            icon    : "i5-nav-chat",
            url     : `settings/${SettingsSection.PRODUCTIVITY}`,
        },
        {
            name    : "Automations",
            icon    : "i5-automation",
            url     : `settings/${SettingsSection.AUTOMATIONS}`,
        },
        {
            name    : SettingsSectionTitleDict[SettingsSection.USERS],
            icon    : "i5-users",
            url     : `settings/${SettingsSection.USERS}`,
        },
        {
            name    : "Access & Permissions",
            icon    : "i5-key",
            url     : `settings/${SettingsSection.ACCESS}`,
        },
        {
            name    : "Time and Resources",
            icon    : "i5-my-time",
            url     : `settings/${SettingsSection.TIME_RESOURCES}`,
        },
        {
            name    : "Billing & Finance",
            icon    : "i5-expenses-light",
            url     : `settings/${SettingsSection.BILLING}`,
        },
        {
            name    : "CRM",
            icon    : "i5-customer",
            url     : `settings/${SettingsSection.CRM}`,
        },
        {
            name    : "Views",
            icon    : "icon i5-view",
            url     : `settings/${SettingsSection.VIEWS}`,
        },
        {
            name    : "System",
            icon    : "i5-log",
            url     : `settings/${SettingsSection.SYSTEM}`,
        },
    ]

    const isAdmin = gd.ac.check.isOrganizationAdmin(gd.companyId)
    if (isAdmin) {
        items.push({
            name    : "Organization account",
            icon    : "i5-organization-profile",
            url     : `settings/${SettingsSection.ACCOUNT}`,
        })
    }

    return (
        <NavigationMenuSection name         = "Organization settings"
                               counter      = {items.length}
                               collapsible  = {true}
                               isOpen       = {!props.collapseState.isCollapsed('organization-settings')}
                               onToggle     = {onToggle}>

            <MenuSettings_Items items               = {items}
                                navigationSection   = {props.navigationSection}/>

        </NavigationMenuSection>
    )

}
